import { render, staticRenderFns } from "./WorkspaceDetail.vue?vue&type=template&id=10adf90e&scoped=true&%3Akey=workspaceDetails.timestamp"
import script from "./WorkspaceDetail.vue?vue&type=script&lang=ts"
export * from "./WorkspaceDetail.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceDetail.vue?vue&type=style&index=0&id=10adf90e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10adf90e",
  null
  
)

export default component.exports